import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=bff44c9e"
import script from "./topBar.vue?vue&type=script&lang=ts"
export * from "./topBar.vue?vue&type=script&lang=ts"
import style0 from "./topBar.vue?vue&type=style&index=0&id=bff44c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MemberCard: require('/app/components/general/memberCard.vue').default})
